import {
    GET_LIVE_MATCHES_START,
    GET_LIVE_MATCHES_SUCCESS,
    GET_LIVE_MATCHES_FAIL,
    GET_UPCOMING_MATCHES_START,
    GET_UPCOMING_MATCHES_SUCCESS,
    GET_UPCOMING_MATCHES_FAIL,
    GET_PAST_MATCHES_START,
    GET_PAST_MATCHES_SUCCESS,
    GET_PAST_MATCHES_FAIL
} from "../../constants/type";
import API from "../utils/api";
import config from "../../constants/config";
import {
    TOURNAMENT_LIST_START,
    TOURNAMENT_LIST_SUCCESS,
    TOURNAMENT_LIST_FAIL,
    HOME_TOURNAMENT_LIST_START,
    HOME_TOURNAMENT_LIST_SUCCESS,
    HOME_TOURNAMENT_LIST_FAIL
} from "../../constants/type";

export const getLiveMatches = (data) => {
    return async function (dispatch) {
        dispatch({ type: GET_LIVE_MATCHES_START });
       await API.getRequestWithoutAuthToken(`${config.BASE_URL}/match/findAllLiveMatches?limit=10&pageNumber=${data.activePage}&tournamentId=` + data.tournamentId).then(response => {
            //success API response
            return dispatch({
                type: GET_LIVE_MATCHES_SUCCESS,
                payload: response
            });

        })
            .catch(error => {
                //console.log("Fali Response login", error)
                return dispatch({ type: GET_LIVE_MATCHES_FAIL, payload: error.response });
            });
    }
}

export const getUpcomingMatches = () => {
    return function (dispatch) {
        dispatch({ type: GET_UPCOMING_MATCHES_START });
        API.getRequestWithoutAuthToken(`${config.BASE_URL}/match?includeTournamentMatch=true&limit=50&pageNumber=1&statusId=1`).then(response => {
            //success API response
            return dispatch({
                type: GET_UPCOMING_MATCHES_SUCCESS,
                payload: response
            });

        })
            .catch(error => {
                //console.log("Fali Response login", error)
                return dispatch({ type: GET_UPCOMING_MATCHES_FAIL, payload: error.response });
            });
    }
}

export const getPastMatches = () => {
    return function (dispatch) {
        dispatch({ type: GET_PAST_MATCHES_START });
        API.getRequestWithoutAuthToken(`${config.BASE_URL}/match/findAllPastMatches`).then(response => {
            //success API response
            return dispatch({
                type: GET_PAST_MATCHES_SUCCESS,
                payload: response
            });
        })
            .catch(error => {
                //console.log("Fali Response login", error)
                return dispatch({ type: GET_PAST_MATCHES_FAIL, payload: error.response });
            });
    }
}

export const getTournamentListing = (data, isTournamentEntry = false) => {
    return async function (dispatch) {
        dispatch({ type: TOURNAMENT_LIST_START });
        let requestPayload = '';
        if (isTournamentEntry) {
            requestPayload = `?limit=` + 12 + `&pageNumber=` + 1
        } else {
            requestPayload = `?limit=` + 12 + `&pageNumber=` + data.activePage + `&sportType=` + data.searchBy.sportType + `&tournamentName=` + data.searchBy.tournamentName + `&tournamentStyle=` + data.searchBy.tournamentStyle
        }

        await API.getRequest(`${config.BASE_URL}/tournament` + requestPayload)
            .then(response => {
                response.isTournamentEntry = isTournamentEntry;
                let fetchedRecords = response.page.pageNumber * response.page.limit;
                data.hasMore = fetchedRecords < response.page.totalElements ? true : false;
                data.isLoading = false;
                dispatch({
                    type: TOURNAMENT_LIST_SUCCESS,
                    payload: response
                });
            })
            .catch(error => {
                data.isLoading = false;
                if (error.response) {
                    return dispatch({ type: TOURNAMENT_LIST_FAIL, payload: error.response });
                } else {
                    return dispatch({ type: TOURNAMENT_LIST_FAIL, payload: error });
                }

            });

    }
}

export const getHomeTournamentList = (data, isTournamentEntry = false) => {
    return async function (dispatch) {
        dispatch({ type: HOME_TOURNAMENT_LIST_START });
        let requestPayload = '';
        if (isTournamentEntry) {
            requestPayload = `?limit=` + 12 + `&pageNumber=` + 1
        } else {
            requestPayload = `?limit=` + 12 + `&pageNumber=` + data.activePage + `&sportType=` + data.searchBy.sportType + `&tournamentName=` + data.searchBy.tournamentName + `&tournamentStyle=` + data.searchBy.tournamentStyle
        }

        await API.getRequest(`${config.BASE_URL}/home/tournaments` + requestPayload)
            .then(response => {
                response.isTournamentEntry = isTournamentEntry;
                let fetchedRecords = response.page.pageNumber * response.page.limit;
                data.hasMore = fetchedRecords < response.page.totalElements ? true : false;
                data.isLoading = false;
                dispatch({
                    type: HOME_TOURNAMENT_LIST_SUCCESS,
                    payload: response
                });
            })
            .catch(error => {
                data.isLoading = false;
                if (error.response) {
                    return dispatch({ type: HOME_TOURNAMENT_LIST_FAIL, payload: error.response });
                } else {
                    return dispatch({ type: HOME_TOURNAMENT_LIST_FAIL, payload: error });
                }

            });

    }
}